import $ from 'jquery';
import mod_consultation from "@/store/mods/clinique/consultations.js"
import mod_analyse from "@/store/mods/clinique/analyses.js"
import mod_examen from "@/store/mods/clinique/examens.js"

export default {
    name: "dropdown-quick-actions",
    components: {},
    props: [],
    data() {
        return {
            consult_activ: false,
            analyse_activ: false,
            examen_activ: false,
            display_error: false,
            analyse_checked: [],
            examen_checked: [],
            list_type_consultations: [],
            list_type_analyses: [],
            list_examens: []
        };
    },
    watch: {
        quick_actions: function() {
            if (!this.quick_actions) {
                this.consult_activ = false;
                this.analyse_activ = false;
                this.examen_activ = false;
            } else {
                this.delayedShow();
                this.display_error = false;
            }
        },
    },
    computed: {
        quick_actions() {
            return this.$store.getters["quickActionsDropdown"];
        },
    },
    mounted() {
        this.selectTypeConsultations();
        this.selectListeAnalyse()
        this.selectListExamens()


        this.$store.dispatch("setQuickActionsDropdown", false);
    },

    methods: {
        selectTypeConsultations() {
            mod_consultation.getListeTypesConsultations().then((type_consultations) => {
                this.list_type_consultations = type_consultations
            })
        },

        selectListeAnalyse() {
            mod_analyse.getAnalyses().then((analyses) => {
                this.list_type_analyses = analyses
            })
        },

        selectListExamens() {
            mod_examen.getExamens().then((examens) => {
                this.list_examens = examens
            })
        },

        clickOnAnalyse() {
            this.doWarningMsg('Le prix de cette analyse n\'a pas été défini')
        },

        clickOnExamen() {
            this.doWarningMsg('Le prix de cet examen n\'a pas été défini')
        },

        choixTypeBon() {
            let analyse = $('input[name="analyse[]"]:checked').length;
            let examen = $('input[name="examen[]"]:checked').length;

           
            if (analyse > 0 && examen == 0) {
                // on affiche le bouton
                $('.valid-choix').fadeIn(1000);
            } else if (analyse == 0 && examen > 0) {
                // on affiche toujours
                $('.valid-choix').fadeIn(1000);
            } else {
                // on cache
                $('.valid-choix').fadeOut(1000);
            }
        },

        leaveQuickAction: function(data) {

            //SET THE SELECTED CONS
            if (data) {
                this.$store.commit("SET_TYPE_ACTION_SELECTED", "bon_consultation")
                this.$store.commit("SET_TYPE_CONS_SELECTED", data);
            }

            $('#b-examen').removeClass('animate animate-zoomIn');
            $('#b-examen').addClass('animate animate-zoomOut');
            $('#b-analyse').removeClass('animate animate-zoomIn');
            $('#b-analyse').addClass('animate animate-zoomOut');
            $('#b-consult').removeClass('animate animate-zoomIn');
            $('#b-consult').addClass('animate animate-zoomOut');

            setTimeout(() => {
                this.$store.dispatch("setQuickActionsDropdown", false);
            }, 500);


            $('.consult_activ').fadeOut(1000);
            $('.analyse_activ').fadeOut(1000);
            $('.examen_activ').fadeOut(1000);

            this.analyse_checked = [];
            this.examen_checked = [];
        },

        validerChoix(variant) {
            this.$store.commit("SET_ANALYSES_SELECTED", []);
            this.$store.commit("SET_EXAMENS_SELECTED", []);
            if (variant == undefined) {
                if (this.analyse_checked.length == 0 && this.examen_checked.length == 0) {
                    this.display_error = true;
                    return;
                }
            }
            
            // enregistrer la sélection
            if (this.analyse_checked.length > 0) {
                this.$store.commit("SET_ANALYSES_SELECTED", this.analyse_checked);
            }

            if (this.examen_checked.length > 0) {
                this.$store.commit("SET_EXAMENS_SELECTED", this.examen_checked);
            } 
            // fin enregistrer la sélection

            if (variant != 1) {
                this.$store.commit("SET_TYPE_ACTION_SELECTED", "bon_medical")
                this.$router.push({ name: 'choice-patient' })
            }

            this.leaveQuickAction();
        },


        delayedShow() {
            setTimeout(() => {
                // this.consult_activ = true;
                $('.consult_activ').fadeIn(1000);

                $('#b-consult').removeClass('animate animate-zoomOut');
                $('#b-consult').addClass('animate animate-zoomIn');
            }, 500);
            setTimeout(() => {
                // this.analyse_activ = true;
                $('.analyse_activ').fadeIn(1000);

                $('#b-analyse').removeClass('animate animate-zoomOut');
                $('#b-analyse').addClass('animate animate-zoomIn');
            }, 1000);
            setTimeout(() => {
                // this.examen_activ = true;
                $('.examen_activ').fadeIn(1000)

                $('#b-examen').removeClass('animate animate-zoomOut');
                $('#b-examen').addClass('animate animate-zoomIn');
            }, 1500);
        },

        doWarningMsg: function(msg) {
            if (this.$toasted != null) this.$toasted.clear()
            this.$toasted.show(msg, {
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                position: 'top-center',
                duration: 2000,
                theme: 'toasted-warning',
                type: 'warning'
            })
        },
    },
};